import { get, post, put } from '../../api';

export const getConexoesSelect = async (idConfiguracao = -1) => {
  const res = await get(`/api/conectores/conexoes/${idConfiguracao}`);

  const result = [];

  res.forEach((item) => {
    const obj = {
      key: `${item.id}-${item.ds}`,
      value: `${item.id}-${item.ds}`,
      title: `${item.id} - ${item.ds} - ${item.banco}`,
    };

    if (!result.some((con) => con.key === obj.key)) result.push(obj);
  });

  return Array.from(result);
};

export const getConexoes = (idConfiguracao) => {
  return get(`/api/conectores/conexoes/${idConfiguracao}`);
};

export const getConexao = (idConfiguracao, id) => {
  return get(`/api/conectores/conexao/${idConfiguracao}/${id}`);
};

export const postConexao = (data) => {
  return post('/api/conectores/conexao', data);
};

export const putConexao = (data) => {
  return put('/api/conectores/conexao', data);
};
